import PatientOverviewHNProgressOverTime from 'dashboard/templates/views/Patient/HN/PatientOverviewHNProgressOverTime';
import RouteRequirements from "../../../../../../../../model/RouteRequirements";

export const routeRequirements = (new RouteRequirements())
    .setEnabledModules(['HEALTHYNUTRITION'])
    .setMinimumAllowedVisit(3);

export default {
    path: 'over-time',
    name: 'PatientOverviewHNProgressOverTime',
    component: PatientOverviewHNProgressOverTime,
    props: true,
    meta: {
        // title: 'Patient Record - Healthy Nutrition',
        title: t => `${t('patient.patientRecord')} - ${t('screens.healthyNutritionSettingsScreen', 'app_mobile')}`,
        routeRequirements
    },
};
